import { Box } from '@machobear/design-system'
import React, { ReactNode } from 'react'

interface PropagationBoundaryProps {
  children: ReactNode
}

export const PropagationBoundary: React.FC<PropagationBoundaryProps> = ({ children }) => {
  return <Box onClick={e => e.stopPropagation()}>{children}</Box>
}
